<abs-modals-and-alerts-component [(modalAction)]="openModal" (modalClosed)="close($event, 'openModal')"
  windowClass="modal-docked" sizeClass="modal-small">
  <abs-modals-and-alerts-content-component id="utf-customer-inactivity-modal-popup">
    <main class="modal-header" tabindex="0">
      <h1 style="display:none;">Fix for sonar issues</h1>
      <h2 id="customer-inactivity-modal-container-heading" modal-title>
        {{cfetLabels.utf_customer_inactivity_modal.heading}}</h2>
      <div class="corner-button">
        <button type="button" class="close-modal-button" id="close-modal" tabindex="0" [attr.aria-label]="'Close'"
          (click)="close($event, 'openModal')" (keyup)="close($event,'openModal')">
          <em aria-label="Close" class="icon-close modal-close-icon" role="img"></em>
        </button>
      </div>
    </main>
    <section class="modal-body" id="body-content-section" modal-content tabindex="0">
      <p id="description" [innerHTML]="cfetLabels.utf_customer_inactivity_modal.description_point1"></p>
      <p id="description">{{cfetLabels.utf_customer_inactivity_modal.description_point2}}</p>
    </section>
    <section class="row no-gutters" id="confirmation-buttons">
      <div class="col-md-6">
        <button type="button" id="btn-leave" (click)="closeApplication($event,'openModal')"
          (keyup)="closeApplication($event,'openModal')" class="btn btn-medium" tabindex="0"><em aria-label=""></em>
          {{cfetButtonLabels.button_labels.utf_cancel_application}}</button>
      </div>
      <div class="col-md-6">
        <button type="button" id="btn-stay" (click)="keepWorking($event,'openModal')"
          (keyup)="keepWorking($event,'openModal')" class="btn btn-medium" tabindex="0"><em aria-label=""></em>
          {{cfetButtonLabels.button_labels.continue}}</button>
      </div>
    </section>
  </abs-modals-and-alerts-content-component>
</abs-modals-and-alerts-component>